import { Sun, Wifi, Snowflake, BedDouble, ChefHat, Tv } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Overline } from "./Reveal";
import { useLightbox } from "./Lightbox";

const icons = [Sun, Wifi, Snowflake, BedDouble, ChefHat, Tv];

const bentoImages = [
  {
    src: "/assets/gallery/terrazzo.jpg",
    alt: "Terrazzo comune con zona salotto — King's Place",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "/assets/gallery/cucina2.jpg",
    alt: "Cucina comune — King's Place",
    span: "lg:col-span-2",
  },
];

const Amenities = () => {
  const { t } = useLang();
  const openLightbox = useLightbox();
  return (
    <section id="servizi" data-testid="amenities-section" className="py-28 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>{t.amenities.overline}</Overline>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl tracking-tight mt-4 max-w-2xl">
            {t.amenities.title}
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#14213D]/70 leading-relaxed max-w-xl">{t.amenities.desc}</p>
        </Reveal>

        <div className="mt-16 lg:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:auto-rows-[200px]">
          <Reveal className={`${bentoImages[0].span} h-full`}>
            <div className="overflow-hidden rounded-[1.25rem] h-full group">
              <img
                src={bentoImages[0].src}
                alt={bentoImages[0].alt}
                loading="lazy"
                onClick={() => openLightbox(bentoImages[0].src, bentoImages[0].alt)}
                className="w-full h-full max-h-[420px] lg:max-h-none object-cover group-hover:scale-105 transition-transform duration-700 ease-out cursor-zoom-in"
              />
            </div>
          </Reveal>
          {t.amenities.items.map((item, i) => {
            const Icon = icons[i];
            const tiles = (
              <Reveal key={item.title} delay={(i % 4) * 0.06} className="h-full">
                <div
                  data-testid={`amenity-tile-${i}`}
                  className="h-full rounded-[1.25rem] border border-[#14213D]/10 p-6 flex flex-col justify-between hover:border-[#D39A2E]/60 hover:bg-[#E9EDF6] transition-[border-color,background-color] duration-300"
                >
                  <Icon size={20} className="text-[#2852A6]" />
                  <div className="mt-6">
                    <h3 className="font-serif text-xl">{item.title}</h3>
                    <p className="text-sm text-[#14213D]/60 mt-1.5 leading-relaxed">{item.text}</p>
                  </div>
                </div>
              </Reveal>
            );
            if (i === 3) {
              return [
                tiles,
                <Reveal key="bento-coffee" delay={0.1} className={`${bentoImages[1].span} h-full`}>
                  <div className="overflow-hidden rounded-[1.25rem] h-full group">
                    <img
                      src={bentoImages[1].src}
                      alt={bentoImages[1].alt}
                      loading="lazy"
                      onClick={() => openLightbox(bentoImages[1].src, bentoImages[1].alt)}
                      className="w-full h-full max-h-[320px] lg:max-h-none object-cover group-hover:scale-105 transition-transform duration-700 ease-out cursor-zoom-in"
                    />
                  </div>
                </Reveal>,
              ];
            }
            return tiles;
          })}
        </div>
      </div>
    </section>
  );
};

export default Amenities;
